import { Observable, throwError } from "rxjs";
import { ScaleStore } from "../scale.store";
import { Regra, RegraDTO } from "src/app/models/regra";

export abstract class RegrasService {

  protected scaleStore: ScaleStore;
  constructor(scaleStore: ScaleStore) {
    this.scaleStore = scaleStore;
  }

  protected handleError(error: any) {
    return throwError(error);
  }

  protected log(message: string) {
    console.log('============= message response ============');
    console.log(message);
  }

  public abstract atualizaRegrasMes(regras: Partial<Regra>[]): Observable<Regra[]>;
  public abstract atualizaSetoresBloqueados(regra: RegraDTO): Observable<Regra[]>;
  public abstract carregaRegrasMes(escalaPeriodoId: number): Observable<Regra[]>;

}
